module.exports = __webpack_public_path__ + "media/images/story/top/step3-d190a1e71171c4d6cfe6cb22a161bdcc.svg";